export enum AdminMutationTypes {
    SET_ADMIN_MENU_ACTIF = "SET_ADMIN_MENU_ACTIF",
    LOAD_SHOPS = "LOAD_SHOPS",
    ADD_SHOP = "ADD_SHOP",
    UPDATE_SHOP = "UPDATE_SHOP",
    SET_BACKEND_VERSION = "SET_BACKEND_VERSION",
}